module.exports = __webpack_public_path__ + "img/financeiros.16786f79.jpg";